export var LegalEntityType;
(function (LegalEntityType) {
    LegalEntityType["Charity"] = "charity";
    LegalEntityType["C_Corporation"] = "c-corporation";
    LegalEntityType["ExtraGovernmentalBody"] = "extra-governmental-body";
    LegalEntityType["LimitedLiabilityCompany"] = "limited-liability-company";
    LegalEntityType["LimitedLiabilityPartnership"] = "limited-liability-partnership";
    LegalEntityType["LimitedPartnership"] = "limited-partnership";
    LegalEntityType["GeneralPartnership"] = "general-partnership";
    LegalEntityType["PensionFund"] = "pension-fund";
    LegalEntityType["S_Corporation"] = "s-corporation";
    LegalEntityType["StateOwnedEnterprise"] = "state-owned-enterprise";
    LegalEntityType["Trust"] = "trust";
    LegalEntityType["Other"] = "other";
})(LegalEntityType || (LegalEntityType = {}));
//# sourceMappingURL=index.js.map